<template>
    <div id="wrapper">
        <div id="pageMask" v-if="pageMaskShowAt">
            <img class="loading-img" src="../../../assets/common/images/loading.gif"/>
            <div class="loading-backgroud"></div>
        </div>
        <div id="wrap">
            <div :style="{'height':( $store.getters.getWindowInfo.height ) + 'px'}">
                <div class="web-docu-wrap hp100" style="padding-right: 0;">
                    <div class="web-docu-con">
                        <div class="web-docu">
                            <div class="web-docu-bar">
                                <div class="web-docu-bar-txt">
                                </div>
                                <div class="web-docu-bar-btn" style="margin-left: calc( 50% - 20px - 71px );float: none;">
                                    <button class="ssmall-rd _bt-gray"
                                            @click="btnPrintClick();">
                                        <div class="img-com _bt-w-print"><span>인쇄</span></div><span>PDF 인쇄 / 다운로드</span>
                                    </button>
                                </div>
                            </div>
                            <hwp ref="hwp"
                                 :refnm="'hwp'"
                                 :initialized-callback-func="initializedCallbackFunc"></hwp>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'commonHwp',
        data: function () {
            return {
                webHwpCtl:null,
                sendPostMessage:null,
                loadHwpInfo: {
                    i5gam: {
                        D001: {
                            fileNm: '20985',
                            orgNm: '견적서',
                            storge: '0/common/',
                            editMode: '0'
                        },
                        D002: {
                            fileNm: '20986',
                            orgNm: '계약서',
                            storge: '0/common/',
                            editMode: '0'
                        },
                        D003: {
                            fileNm: '20987',
                            orgNm: '납품확인서',
                            storge: '0/common/',
                            editMode: '0'
                        },
                        D004: {
                            fileNm: '20983',
                            orgNm: '월간출석부',
                            storge: '0/common/',
                            editMode: '0'
                        },
                        D005: {
                            fileNm: '33182',
                            orgNm: '거래명세서',
                            storge: '0/common/',
                            editMode: '0'
                        },
                        D006: {
                            fileNm: '816589',
                            orgNm: '거래명세서',
                            storge: '0/common/',
                            editMode: '0'
                        }
                    }
                }
            }
        },
        computed: {
            pageMaskShowAt:function(){
                return this.$store.getters.getPageMaskShowAt;
            },
        },
        methods: {
            initializedCallbackFunc: function(sendPostMessage,webHwpCtl){
                this.sendPostMessage = sendPostMessage;
                this.webHwpCtl = webHwpCtl;

                this.loadHwp();
            },
            loadHwp: function(){
                const _this = this;
                const hwpInfo = this.loadHwpInfo[this.$route.params.docSe][this.$route.params.docCode];

                this.axios.post(
                    '/i5gam/loadHwpFile.act',
                    hwpInfo
                ).then(function(response) {
                    const hwpFileInfo = response.data.hwpFileInfo;
                    _this.sendPostMessage(
                        'loadHwpContent',
                        {
                            'content' : hwpFileInfo.content,
                            'editMode': 1
                        },
                        _this.loadHwpCallbackFunc
                    );
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            loadHwpCallbackFunc: function(){
                const setFieldList = this.$route.params.setFieldList;
                if(setFieldList) this.sendPostMessage('setFieldList',{'fieldList' : setFieldList},this.setFieldListCallbackFunc);

                const fieldList = this.$route.params.fieldList;
                if(fieldList) this.sendPostMessage('loadAutoCmpltData', {'fieldList' : fieldList}, this.setFieldListCallbackFunc);

				if(!setFieldList && !fieldList){
					this.$store.commit('setPageMaskShowAt',false);
				}
            },
            setFieldListCallbackFunc: function(){
                const hwpInfo = this.loadHwpInfo[this.$route.params.docSe][this.$route.params.docCode];
				this.sendPostMessage("changeEditMode",{"editMode" : hwpInfo.editMode});
                this.sendPostMessage("runAction",{action:'HwpCtrl.MovePos(2);',rtcode:0},null);
				this.$store.commit('setPageMaskShowAt',false);
            },
            btnPrintClick: function(){
                this.sendPostMessage("printDocument",null,null);
            }
        },
        mounted:function(){
            //console.log(this.$route.params);
        },
    }
</script>

<style scoped>

</style>